import React, {useState} from 'react'
import {Button, Form, Input, Modal, InputNumber, message} from "antd";
import {createProductionCost} from "../../services/serviceProductionCost";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const {TextArea} = Input
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const ProductionCostCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [loadings, setLoadings] = useState([])


    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)

        if (list.costRatio <= 0 || !list.costRatio) {
            message.error(`Oran değeri 0'dan küçük veya eşit olamaz`)
        } else {
            let requestObj = {
                name: list.costName,
                code: list.costCode,
                description: list.costDescription,
                ratio: list.costRatio
            }

            createProductionCost(requestObj)
                .then(() => {
                    exitLoadingState(setLoadings)
                    modalCloser()
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
        }
    }


    return (
        <React.Fragment>
            <Modal
                title={'Üretim Gideri Ekle'}
                open={show}
                closable={false}
                footer={[
                    <Button
                        key={'SubmitButton'}
                        type={'primary'}
                        loading={loadings[0]}
                        onClick={() => handleSubmit(form.getFieldsValue())}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={() => modalCloser()}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                >
                    <Form.Item
                        label={'Adı'}
                        name={'costName'}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Kodu'}
                        name={'costCode'}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Açıklaması'}
                        name={'costDescription'}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item
                        label={'Oranı'}
                        name={'costRatio'}
                    >
                        <InputNumber min={0} step={0.1}/>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default ProductionCostCreate